import { createReducer } from 'typesafe-actions';

import { disconnectWallet, setActiveWalletAndKey } from './actions';
import { WalletType } from './types';

type State = {
  activeWalletType: WalletType | null;
  activePublicKey: string | null;
};

const initialState: State = {
  activeWalletType: null,
  activePublicKey: null,
};

export default createReducer(initialState)
  .handleAction(
    setActiveWalletAndKey,
    (state, { payload: { walletType, publicKey } }): State => ({
      ...state,
      activeWalletType: walletType,
      activePublicKey: publicKey,
    })
  )
  .handleAction(
    disconnectWallet,
    (state, { payload }): State => ({
      ...state,
      activeWalletType: null,
      activePublicKey: null,
    })
  );
